import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Layout } from '../components/Layout';
import { BusinessProfile } from '../pages/BusinessProfile';
import { CustomHtmlPage } from '../pages/CustomHtmlPage';
import { Dashboard } from '../pages/Dashboard';
import { GalleryManager } from '../pages/GalleryManager';
import { Insights } from '../pages/Insights';
import { Login } from '../pages/Login';
import { ProductsManager } from '../pages/ProductsManager';
import { useAuthStore } from '../stores/authStore';

function RequireAuth({ children }: { children: ReactElement }) {
  const status = useAuthStore((s) => s.status);

  if (status === 'idle' || status === 'checking') {
    return <p className="p-6 text-sm text-slate-500">Loading…</p>;
  }
  if (status !== 'authenticated') {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="profile" element={<BusinessProfile />} />
        <Route path="products" element={<ProductsManager />} />
        <Route path="gallery" element={<GalleryManager />} />
        <Route path="insights" element={<Insights />} />
        <Route path="html-page" element={<CustomHtmlPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
